import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Headers from "../components/Headers";
import { Link } from "react-router-dom";
import Carousel from "react-multi-carousel";
import Products from "../components/products/Products";
import Footer from "../components/Footer";
import { get_category, get_products } from "../store/reducers/homeReducer";
import { aboutUs } from "../constants/AboutUsContent";
import { logos } from "../constants/logos";
const About = () => {
  const dispatch = useDispatch();
  const { products, latest_product, topRated_product, discount_product } =
    useSelector((state) => state.home);
  useEffect(() => {
    dispatch(get_products());
  }, []);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 6,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 6,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4,
    },
    mdtablet: {
      breakpoint: { max: 991, min: 464 },
      items: 4,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 3,
    },
    smmobile: {
      breakpoint: { max: 640, min: 0 },
      items: 2,
    },
    xsmobile: {
      breakpoint: { max: 440, min: 0 },
      items: 1,
    },
  };
  return (
    <div className="w-full">
      <section
        className="h-[280px] bg-cover bg-no-repeat relative bg-center"
        style={{
          backgroundImage: `url(${process.env.REACT_APP_CLIENT_URL}/images/aboutBg.jpg)`,
        }}
      >
        <Headers />
        <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto mt-20 ">
            <div className="div-gradient-t1">
              <h1 className="sm:text-[28px] text-[45px] gradient-t0">
                Tabbibi - عن طببي
              </h1>
              <div className="w-[200px] sm:w-[150px] h-[6px] bg-[#fefefe] rounded-full mt-3"></div>
            </div>
          </div>
        </div>
      </section>

      <div className=" px-[10%] pb-20 flex justify-center items-center flex-col">
        <div className="block mt-10">
          <p className="mt-6 text-lg text-slate-600 text-right">
            في ظل التطور التكنولوجي المتسارع، أصبح من الضروري التفكير في طرق
            حديثة وعصرية لتقديم الخدمات الطبية والتعريف بالأطباء بشكل يتناسب مع
            متطلبات العصر. لم يعد الاعتماد على الأساليب التقليدية كافيًا في عالم
            يعتمد على السرعة والدقة والتكنولوجيا
          </p>
        </div>
        <div className="div-gradient-t1">
          <h1 className="sm:text-[22px] gradient-t1">
            {" "}
            فريق طبيبي - خبراء في خدمتك{" "}
          </h1>
        </div>
        <div className="block">
          <p className="mt-6 text-lg text-slate-600 text-right">
            وراء منصة طبيبي يقف فريق من الخبراء والمتخصصين في المجال الطبي
            والتكنولوجي، يعملون على تقديم خدمات ذات جودة عالية لضمان تجربة مريحة
            للمستخدمين. نسعى دائمًا لتوفير المعلومات الطبية الموثوقة وإتاحة
            الفرصة للمرضى للتواصل المباشر مع الأطباء بكل سهولة وشفافية
          </p>
        </div>
        <div className="div-gradient-t1">
          <h1 className="sm:text-[22px] gradient-t1">{aboutUs[0].title}</h1>
        </div>
        <div className="block">
          {/* Display the rest of the paragraphs */}
          {aboutUs[0].description.map((paragraph, index) => (
            <p key={index} className="mt-6 text-lg text-slate-600">
              {paragraph}
            </p>
          ))}
        </div>

        <div className="block mt-3">
          <p className="mt-6 text-lg text-slate-600 text-right">
            طبيبي ليس مجرد منصة طبية، بل هو خطوة نحو مستقبل أكثر تطورًا في عالم
            الرعاية الصحية. نطمح لأن نكون الجسر الذي يربط المرضى بالأطباء بسهولة
            وفعالية، مما يجعل الحصول على الرعاية الطبية أكثر سهولة وراحة
          </p>
        </div>
      </div>
      <div className="div-gradient-t1 text-center">
        <h1 className="sm:text-[22px] text-2xl gradient-t1 text-center">
          فريق طبيبي
        </h1>
      </div>
      <div className="w-[85%] sm:w-[92%] flex flex-wrap mx-auto  mt-10 mb-10">
        <div className="w-full grid grid-cols-3 md-lg:grid-cols-3 md:grid-cols-1  gap-6 sm:gap-3">
          {aboutUs.slice(1, 4).map((a, i) => (
            <div
              key={i}
              className="border border-mainColor rounded-2xl sm:rounded-lg group transition-all duration-500 hover:shadow-md hover:-mt-3"
            >
              <Link to={a.link}>
                <div className="relative flex overflow-hidden justify-center  ">
                  <img
                    className="sm:w-full w-full h-[300px] sm:h-[280px] rounded-t-2xl sm:rounded-t-lg object-cover object-center"
                    src={a.photo}
                    alt={a.name}
                  />
                  <ul className="flex bg-mainBg/35 backdrop-blur-sm w-full  bottom-0 justify-center items-center absolute  ">
                    <div className="w-full h-[38px] cursor-pointe flex justify-center items-center bg-mainColor/70 backdrop-blur-sm ">
                      <h2
                        className="text-lg sm:text-sm font-semibold"
                        style={{ textShadow: "-2px 2px 2px #00022e43" }}
                      >
                        {a.name}
                      </h2>
                    </div>
                  </ul>
                </div>
                <div className="mt-1 p-3">
                  <h2 className="text-md sm:text-sm font-semibold text-center text-[#00b8fb]">
                    {a.job}
                  </h2>
                  <h2 className="text-md sm:text-sm font-semibold text-center text-[#00b8fb]">
                    {a.jobAr}
                  </h2>
                  <h3 className="text-sm sm:text-xs font-semibold text-center text-slate-600">
                    {a.description}{" "}
                  </h3>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
      <div className="px-10 mb-32 mt-24">
        <div className="flex flex-col justify-center items-center text-center px-20 sm:px-1">
          <h1 className="sm:text-[22px] text-2xl gradient-t1 ">شركاؤنا</h1>
          <h2 className="text-md sm:text-xs mt-4">
            في إطار القرار الوزاري رقم 1275 المؤرخ في 22 سبتمبر 2022، الصادر عن
            وزارة التعليم العالي والبحث العلمي، تأسست مؤسسة الشريف للخدمات
            الصحية الرقمية – منصة طبيبي – بتاريخ 17 نوفمبر 2024
          </h2>
          <h2 className="text-md sm:text-xs my-2">
            حصلت المؤسسة على علامة مشروع مبتكر من قبل وزارة اقتصاد المعرفة
            والمؤسسات الناشئة، تأكيدًا لالتزامها بتقديم حلول رقمية متطورة في
            مجال الخدمات الصحية
          </h2>
        </div>
        <Carousel
          autoPlay={true}
          infinite={true}
          arrows={true}
          responsive={responsive}
          transitionDuration={500}
        >
          {logos.map((l, i) => (
            <Link
              className="m-5 block pb-8 items-center align-middle justify-center"
              key={i}
            >
              <div className="w-full h-full flex  px-2 py-5 justify-center align-middle items-center    ">
                <img
                  src={l.photo}
                  alt="logo"
                  className="flex w-[100px] rounded-full border-2 border-mainColor"
                />
              </div>
            </Link>
          ))}
        </Carousel>
      </div>

      <Footer />
    </div>
  );
};

export default About;
